import useMutationUserCreateUpdate from './user-use-mutation-create-update';
import useMutationUserSendPass from "./user-use-mutation-send-password";
import useMutationUserDelete from "./user-use-mutation-delete";
import useMutationUserReport from "./user-use-mutation-report";

export { default as useCanCreateUsers } from './use-can-create-users';
export { default as useCanAssignUserGroups } from './use-can-assign-usergroups';


export const userUseMutation = {
  createUpdate: useMutationUserCreateUpdate,
  sendPass: useMutationUserSendPass,
  delete: useMutationUserDelete,
  report: useMutationUserReport,
}
